import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from 'src/app/_services/identity.service';

@Component({
  selector: 'app-loginwithlink',
  templateUrl: './loginwithlink.component.html',
  styleUrls: ['./loginwithlink.component.css']
})
export class LoginwithlinkComponent implements OnInit {
    returnUrl: string;
  constructor(
    private identityService: IdentityService,
    private activeRoute :ActivatedRoute,
    private router:Router) { }
link:any;
  ngOnInit() {

     this.link = this.activeRoute.snapshot.paramMap.get('link');

     if(this.link){

      this.identityService.loginwithlink(this.link).subscribe(res=>{
           this.setUserInStorage(res);
                localStorage.removeItem('currentLayoutStyle');
                let returnUrl = '/panel';
                if (this.returnUrl) {
                  returnUrl = this.returnUrl;
                }
                this.router.navigate([returnUrl]);
      });
     }
     else{
        this.router.navigate(['/login']);
     }
  }
 setUserInStorage(res) {
        if (res.user) {
            localStorage.setItem('currentUser', JSON.stringify(res.user));
        } else {
            localStorage.setItem('currentUser', JSON.stringify(res));
        }
    }
}
